import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ico_Open",
  "use": "ico_Open-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"ico_Open\">\n    <path data-name=\"Path 12234\" d=\"m4 8.708.707-.707 7.647 7.646L20 8l.707.707-8 8a.5.5 0 0 1-.707 0z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol